import React, { Component } from "react";
import Navbar from "./components/Navbar";

import TextForm from "./components/TextForm";
import About from "./components/About";
import "./App.css";
import { render } from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// import your route components too

const App = () => {
  return (
    <>
      
      <BrowserRouter>
        <Navbar title="TextAnalyzer"></Navbar>
        <Routes>
        <Route path="/" element={<TextForm headings="Text-Analyzer | Analyze your words, characters and sentences" />}> </Route>
        <Route path="/about" element={<About/>}></Route>
            
        </Routes>
      </BrowserRouter>
  
    </>
  );
};

export default App;
